import { axiosBase } from '@/services/axios-base';
import { HRMUserEngagementTimeSheetDTO } from '@/models';

export const fetchHRMMemberTimeSheets = (
  projectAssessmentId: number
): Promise<{ data: HRMUserEngagementTimeSheetDTO[] }> => {
  return axiosBase.get(`/api/assessment/${projectAssessmentId}/hrmUserEngagements`);
};

export const fetchEditedHRMTimeSheets = (
  projectAssessmentId: number
): Promise<{ data: HRMUserEngagementTimeSheetDTO[] }> => {
  return axiosBase.get(`/api/assessment/${projectAssessmentId}/hrmTimeSheets`);
};
